import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE } from "../api";
import "./Admin.css";
import "./AdminTransactions.css";

const AdminTransactions = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTransaction, setSelectedTransaction] = useState(null);

    useEffect(() => {
        const fetchTransactions = async () => {
            const token = localStorage.getItem("token");
            try {
                const response = await fetch(`${API_BASE}/api/admin/transactions`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                const data = await response.json();
                setTransactions(data);
            } catch (error) {
                console.error("Error fetching transactions:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchTransactions();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "/#/admin/login";
    };

    const formatDate = (dateStr) => {
        if (!dateStr || (typeof dateStr === 'object' && Object.keys(dateStr).length === 0)) return "-";
        try {
            return new Date(dateStr).toLocaleString();
        } catch {
            return "-";
        }
    };

    const safeRender = (val) => {
        if (val === null || val === undefined) return "-";
        if (typeof val === 'object') {
            if (Object.keys(val).length === 0) return "-";
            return JSON.stringify(val);
        }
        return val;
    };

    const stats = {
        total: transactions.length,
        success: transactions.filter(t => String(t.Status || "").toLowerCase() === "success").length,
        failed: transactions.filter(t => String(t.Status || "").toLowerCase() === "failed").length,
        revenue: transactions.filter(t => String(t.Status || "").toLowerCase() === "success")
                            .reduce((acc, t) => acc + (Number(t.Amount) || 0), 0)
    };

    return (
        <div className="admin-transactions-wrapper">
            <header className="tx-header-section">
                <div className="tx-title">
                    <h1>Financial Transactions</h1>
                </div>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <Link to="/admin/dashboard" className="lora-admin-btn">Dashboard</Link>
                    <button onClick={handleLogout} className="lora-admin-btn lora-admin-btn-logout">Logout</button>
                </div>
            </header>

            <div className="tx-stats-grid">
                <div className="tx-stat-item">
                    <span className="tx-stat-label">Total Volume</span>
                    <span className="tx-stat-value">₹{stats.revenue.toLocaleString()}</span>
                </div>
                <div className="tx-stat-item">
                    <span className="tx-stat-label">Transactions</span>
                    <span className="tx-stat-value">{stats.total}</span>
                </div>
                <div className="tx-stat-item">
                    <span className="tx-stat-label">Successful</span>
                    <span className="tx-stat-value" style={{color: 'var(--admin-tx-success)'}}>{stats.success}</span>
                </div>
                <div className="tx-stat-item">
                    <span className="tx-stat-label">Failed</span>
                    <span className="tx-stat-value" style={{color: 'var(--admin-tx-failed)'}}>{stats.failed}</span>
                </div>
            </div>

            <nav className="lora-admin-tabs" style={{ marginBottom: '30px' }}>
                <Link to="/admin/dashboard" className="lora-admin-tab">Overview</Link>
                <Link to="/admin/enrollments" className="lora-admin-tab">Enrollments</Link>
                <Link to="/admin/transactions" className="lora-admin-tab active">Transactions</Link>
            </nav>

            {loading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>Loading transaction data...</div>
            ) : transactions.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>No transactions recorded yet.</div>
            ) : (
                <div className="tx-grid">
                    {transactions.map((tr) => (
                        <div 
                            key={tr.Id} 
                            className="tx-card"
                            onClick={() => setSelectedTransaction(tr)}
                        >
                            <span className={`tx-card-status ${String(tr.Status || "").toLowerCase() === 'success' ? 'tx-status-success' : 
                                             String(tr.Status || "").toLowerCase() === 'failed' ? 'tx-status-failed' : 'tx-status-pending'}`}>
                                {safeRender(tr.Status)}
                            </span>
                            <span className="tx-amount">₹{Number(tr.Amount || 0).toLocaleString()}</span>
                            <span className="tx-merchant-id">{safeRender(tr.MerchantTransactionId)}</span>
                            
                            <div className="tx-info-row">
                                <span>👤</span> {safeRender(tr.ChildName)}
                            </div>
                            <div className="tx-info-row">
                                <span>📧</span> {safeRender(tr.Email)}
                            </div>
                            <div className="tx-info-row">
                                <span>🔄</span> Attempts: {safeRender(tr.AttemptCount)}
                            </div>

                            <div className="tx-footer">
                                <span className="tx-date">{formatDate(tr.CreatedAt)}</span>
                                <span style={{ color: 'var(--admin-tx-primary)', fontWeight: '700' }}>Details →</span>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Transaction Detail Modal */}
            {selectedTransaction && (
                <div className="tx-modal-overlay" onClick={() => setSelectedTransaction(null)}>
                    <div className="tx-modal-content" onClick={e => e.stopPropagation()}>
                        <div className="tx-modal-header">
                            <h3>Transaction Details</h3>
                            <button className="tx-modal-close" onClick={() => setSelectedTransaction(null)}>&times;</button>
                        </div>
                        <div className="tx-modal-body">
                            <div className="tx-detail-group">
                                <h4>Payment Overview</h4>
                                <div className="tx-detail-grid">
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Status</span>
                                        <span className={`tx-card-status ${String(selectedTransaction.Status || "").toLowerCase() === 'success' ? 'tx-status-success' : 'tx-status-pending'}`}
                                              style={{ display: 'inline-block', width: 'fit-content', marginTop: '5px' }}>
                                            {safeRender(selectedTransaction.Status)}
                                        </span>
                                    </div>
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Amount</span>
                                        <span className="tx-detail-value" style={{ fontSize: '1.4rem' }}>₹{Number(selectedTransaction.Amount || 0).toLocaleString()}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="tx-detail-group">
                                <h4>Transaction Identifiers</h4>
                                <div className="tx-detail-grid">
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Merchant TX ID</span>
                                        <span className="tx-detail-value" style={{ color: 'var(--admin-tx-primary)', fontFamily: 'monospace' }}>
                                            {safeRender(selectedTransaction.MerchantTransactionId)}
                                        </span>
                                    </div>
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Gateway TX ID</span>
                                        <span className="tx-detail-value" style={{ fontFamily: 'monospace' }}>
                                            {safeRender(selectedTransaction.PhonePeTransactionId)}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="tx-detail-group">
                                <h4>Enrollment Information</h4>
                                <div className="tx-detail-grid">
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Child Name</span>
                                        <span className="tx-detail-value">{safeRender(selectedTransaction.ChildName)}</span>
                                    </div>
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Parent Email</span>
                                        <span className="tx-detail-value">{safeRender(selectedTransaction.Email)}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="tx-detail-group" style={{ marginBottom: 0 }}>
                                <h4>Audit Log</h4>
                                <div className="tx-detail-grid">
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">First Attempt</span>
                                        <span className="tx-detail-value">{formatDate(selectedTransaction.CreatedAt)}</span>
                                    </div>
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Last Update</span>
                                        <span className="tx-detail-value">{formatDate(selectedTransaction.UpdatedAt)}</span>
                                    </div>
                                    <div className="tx-detail-item">
                                        <span className="tx-detail-label">Attempt Count</span>
                                        <span className="tx-detail-value">{safeRender(selectedTransaction.AttemptCount)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminTransactions;
